import { render } from "./CouncilComponent.vue?vue&type=template&id=bdd59be6"
import script from "./CouncilComponent.vue?vue&type=script&lang=js"
export * from "./CouncilComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__